module.exports = __webpack_public_path__ + "img/03.7a6426c4.jpg";